import { useState } from 'react'
import {SubscribeModal} from 'ppp'
import {gaEvent} from 'shared'

export const SubscribeButton = (props) => {
  const [show, setShow] = useState(false)

  const handleClick = () => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__top')
    setShow(true)
  }

  const onHide = () => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__top')
    setShow(false)
  }

  return <div className='w-100 m-t-xs'>
    <strong>Fans: {props.project.newsletter_subscriptions_count} </strong>
    <a onClick={handleClick} style={{ color: '#357C00' }}>
      <i className='fa fa-lg fa-heart m-l-xs m-r-xs' style={{ color: '#FF6F6C'}}/>
      {I18n.t('projects.show.stats.become_a_fan')}
    </a>

    <SubscribeModal show={show} project={props.project} url={props.url} onHide={onHide} />
  </div>
}
